export const INTERNAL_KEYS = {
  all: () => ["internal"] as const,
  organizations: () => [...INTERNAL_KEYS.all(), "organizations"] as const,
};
